import Service from '../../balancer-farm-subgraph.service';
import queryBuilder from './query';
import { FlakeCirculates, QueryBuilder } from '../../types';

export default class flakeCirculates {
  service: Service;
  query: QueryBuilder;

  constructor(service: Service, query: QueryBuilder = queryBuilder) {
    this.service = service;
    this.query = query;
  }

  public async get(args = {}, attrs = {}): Promise<FlakeCirculates[]> {
    const query = this.query(args, attrs);
    const data = await this.service.client.get(query);
    return data.flakeCirculates;
  }
}
